import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchWorkOrderDetail(id) {
  const { data: raw } = await request.get(`/mom/work-order/${id}`);
  return parseVer4DetailResponse(raw);
}
